import { render } from "./TeacherCardWork.vue?vue&type=template&id=c12889f0&scoped=true"
import script from "./TeacherCardWork.vue?vue&type=script&lang=js"
export * from "./TeacherCardWork.vue?vue&type=script&lang=js"

import "./TeacherCardWork.vue?vue&type=style&index=0&id=c12889f0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c12889f0"]])

export default __exports__